import type { InstitutionTheme } from '../types';
import { sdsuColors } from './colors';

// SDSU institutional theme (W44 S3).
//
// Brand strings from the 2026-2027 catalog + brand site; "my.SDSU" is the
// PeopleSoft student portal (registration, records) per the S1 decisions
// (2026-08-31). Colors per ./colors.ts (Bright Red + Black).
//
// Example course codes vetted against the S0 catalog probe (CS B.S. program
// page poid 11969 + AP table): CS 150 (Introductory Computer Programming —
// major prep), E E 210 (Circuit Analysis I — a SPACED subject prefix, the
// SDSU-specific shape), POL S 102 (American Political Institutions — the
// American Institutions requirement). First entry is the primary example.
export const sdsuTheme: InstitutionTheme = {
  slug: 'sdsu',
  universityName: 'San Diego State University',
  universityShortName: 'SDSU',
  registrationPortalName: 'my.SDSU',
  exampleCourseCodes: ['CS 150', 'E E 210', 'POL S 102'],
  colors: sdsuColors,
};
